import { render, staticRenderFns } from "./StateButton.vue?vue&type=template&id=45bcdd56&"
import script from "./StateButton.vue?vue&type=script&lang=ts&"
export * from "./StateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports